import React from 'react';
import { FieldImage, Fit, LongText, Text, fs } from '../parts/fields';
import { Logo, useFieldSize } from '../parts/chrome';
import { img, useSlide } from '../parts/context';

// #region QuoteLayout
/** A testimonial: the words large, who said it underneath, an optional photo or logo beside. */
export const QuoteLayout: React.FunctionComponent = (): React.ReactElement => {
    const { slide, edit } = useSlide();
    const withImage = edit || !!img(slide.fields.image);
    const size = useFieldSize('quote', withImage ? [[90, 62], [160, 52], [240, 45], [999, 40]] : [[90, 72], [160, 60], [240, 52], [999, 46]]);
    return (
        <>
            <div className="wd-pad" style={{ flexDirection: 'row', alignItems: 'center', gap: 120, paddingTop: 120 }}>
                {withImage ? <FieldImage k="image" framed label="Add a photo or logo" style={{ width: 560, height: 680, flex: 'none' }} /> : null}
                <Fit style={{ flex: 1, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <span aria-hidden="true" className="wd-h" style={{ fontSize: fs(220), lineHeight: 0.7, color: 'var(--wd-accent)', height: fs(110), marginBottom: 24, display: 'block' }}>“</span>
                    <LongText k="quote" as="blockquote" className="wd-h" style={{ fontSize: fs(size), lineHeight: 1.22, fontWeight: 500, maxWidth: withImage ? 1000 : 1440, textWrap: 'pretty' } as React.CSSProperties} placeholder="What they said" max={320} />
                    <div style={{ marginTop: 56, display: 'flex', alignItems: 'center', gap: 24 }}>
                        <span className="wd-rule" style={{ width: 56 }} />
                        <div>
                            <Text k="by" className="wd-h" style={{ fontSize: fs(32), letterSpacing: 0 }} placeholder="Name" max={60} />
                            <Text k="role" className="wd-muted" style={{ fontSize: fs(26), marginTop: 4 }} placeholder="Role, company (optional)" max={80} />
                        </div>
                    </div>
                </Fit>
            </div>
            <Logo />
        </>
    );
};
